import { computeCasingLabel } from "@/models/equipment/casings/properties";
import { computeTubingLabel } from "@/models/equipment/tubings/properties";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderWellCompletionCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => {
  return [
    {
      section: "Well Completion",
      label: "Top Production Casing",
      targetUnit: null,
      value: computeCasingLabel(
        scenario.wellProperties.value?.r_top_casing,
        targetUnits.largeLengthUnit.label === "Meters"
      )
    },
    {
      section: "Well Completion",
      label: "Top Casing Depth",
      targetUnit: targetUnits.largeLengthUnit,
      value: scenario.wellProperties.value?.top_casing_length_feet
    },
    {
      section: "Well Completion",
      label: "Middle Production Casing",
      targetUnit: null,
      value: ""
    },
    {
      section: "Well Completion",
      label: "Middle Casing Depth",
      targetUnit: null,
      value: ""
    },
    {
      section: "Well Completion",
      label: "Lower Production Casing",
      targetUnit: null,
      value: computeCasingLabel(
        scenario.wellProperties.value?.r_bottom_casing,
        targetUnits.largeLengthUnit.label === "Meters"
      )
    },
    {
      section: "Well Completion",
      label: "Lower Casing Depth",
      targetUnit: targetUnits.largeLengthUnit,
      value: scenario.wellProperties.value?.bottom_casing_length_feet
    },
    {
      section: "Well Completion",
      label: "Top of Perfs MD",
      targetUnit: targetUnits.largeLengthUnit,
      value:
        scenario.wellProperties.value?.top_of_perforations_measured_depth_feet
    },
    {
      section: "Well Completion",
      label: "Top of Perfs TVD",
      targetUnit: targetUnits.largeLengthUnit,
      value:
        scenario.wellProperties.value
          ?.top_of_perforations_true_vertical_depth_feet
    },
    {
      section: "Well Completion",
      label: "Top Production Tubing",
      targetUnit: null,
      value: computeTubingLabel(
        scenario.wellProperties.value?.r_top_tubing,
        targetUnits.largeLengthUnit.label === "Meters"
      )
    },
    {
      section: "Well Completion",
      label: "Top Tubing Depth",
      targetUnit: targetUnits.largeLengthUnit,
      value: scenario.wellProperties.value?.top_tubing_length_feet
    },
    {
      section: "Well Completion",
      label: "Top Tubing Weight",
      targetUnit: targetUnits.massUnit,
      value: calcs.equipmentWeights.topTubingWeightLbs
    },
    {
      section: "Well Completion",
      label: "Lower Production Tubing",
      targetUnit: null,
      value: computeTubingLabel(
        scenario.wellProperties.value?.r_bottom_tubing,
        targetUnits.largeLengthUnit.label === "Meters"
      )
    },
    {
      section: "Well Completion",
      label: "Lower Tubing Depth",
      targetUnit: targetUnits.largeLengthUnit,
      value: scenario.wellProperties.value?.bottom_tubing_length_feet
    },
    {
      section: "Well Completion",
      label: "Lower Tubing Weight",
      targetUnit: targetUnits.massUnit,
      value: calcs.equipmentWeights.bottomTubingWeightLbs
    }
  ];
};
